import { useLayoutEffect } from 'react'
import { Outlet, useLocation } from '@/router/navigation'
import { isWidgetRuntimeActive } from '@/shared/utils/widgetPortal'
import { SiteFooter } from './SiteFooter'
import { SiteHeader } from './SiteHeader'
import { CookieConsent } from '@/shared/components/CookieConsent'

export function RootLayout() {
  const { pathname } = useLocation()
  const isWidget = isWidgetRuntimeActive()
  const shellClassName = isWidget ? 'flex flex-col bg-white' : 'flex min-h-screen flex-col'
  const mainClassName = isWidget ? '' : 'academy-site-canvas flex-1'
  const securityStripClassName = isWidget
    ? 'mt-8 border-t border-gray-100 bg-white px-4 py-5'
    : 'border-t border-gray-100 bg-gray-50 px-4 py-5'

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return (
    <div className={shellClassName}>
      {!isWidget && <SiteHeader />}
      <main id="main-content" className={mainClassName}>
        <Outlet />
      </main>
      <div className={securityStripClassName}>
        <div className="mx-auto flex max-w-2xl items-start justify-center gap-2.5 text-center">
          <div>
            <p className="inline-flex items-center gap-1 text-[13px] font-semibold text-gray-700">
              Your information is protected.
              <svg
                className="h-3.5 w-3.5 shrink-0 text-green-600"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                <polyline points="9 12 11 14 15 10" />
              </svg>
            </p>
            <p className="mt-0.5 text-[12px] leading-5 text-gray-500">
              This website uses secure encryption to help keep your personal data safe. Any
              information you enter, including sensitive details, is handled securely and kept
              confidential.
            </p>
          </div>
        </div>
      </div>
      {!isWidget && <SiteFooter />}
      {!isWidget && <CookieConsent analyticsEnabled />}
    </div>
  )
}
